(() => {
  const header = document.querySelector('.ha-header');
  if (!header) return;
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash.startsWith('#ha-group-')) return;
    const group = document.getElementById(url.hash.slice(1));
    if (group) { const detail = group.querySelector('details'); if (detail) detail.open = true; }
  });
  header.querySelectorAll('.ha-nav > details').forEach(detail => {
    detail.addEventListener('toggle', () => {
      if (!detail.open) return;
      header.querySelectorAll('.ha-nav > details').forEach(other => { if (other !== detail) other.open = false; });
    });
  });
  document.addEventListener('click', event => { if (!header.contains(event.target)) header.querySelectorAll('details[open]').forEach(detail => { detail.open = false; }); });
  header.addEventListener('click', event => { if (event.target.closest('a')) header.querySelectorAll('details[open]').forEach(detail => { detail.open = false; }); });
  header.addEventListener('keydown', event => { if (event.key === 'Escape') { const expanded = header.querySelector('details[open]'); header.querySelectorAll('details[open]').forEach(detail => { detail.open = false; }); expanded?.querySelector('summary')?.focus(); } });
})();
